<a [href]="url | safe" [class]="{ disabled: !url }" target="_blank">
  <ng-content></ng-content>
</a>
